<template>
  <div class="container">
    <div class="section-1">
      <h1>Stay tuned, our new <span>AsiaSports</span> is coming soon!</h1>
      <div class="subtitle">
        To provide a better user experience, our website will undergo a full
        upgrade.
      </div>
    </div>
    <div class="section-2">
      <img src="../../static/images/iphone-deco-home.png" alt="" />
      <div class="asl-link-container">
        <a class="asl-link-button" :href="url" target="_self">
          <div class="al-link-logo-text">
            <img src="../../static/images/as-live-app-icon.png" alt="" />
            <div class="asl-link-text">AS Live.tv</div>
          </div>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63619 2.66669 2.66666 8.63622 2.66666 16C2.66666 23.3638 8.63619 29.3334 16 29.3334Z"
              stroke="#121416"
              stroke-width="1.5"
            />
            <path
              d="M10.6667 16C16.9151 16 15.0849 16 21.3333 16M21.3333 16L17.3333 12M21.3333 16L17.3333 20"
              stroke="#121416"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        <p>
          If you wish to continue watching live matches during the upgrade,
          please click on the button - AS Live.tv
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "https://www.aslive.tv/",
    };
  },
};
</script>

<style scoped>
h1 {
  line-height: 120%;
  color: #121416;
  font-size: 48px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1rem;
}
h1 span {
  color: #28a745;
}
.section-1 {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 60%;
  margin: 2.5rem 20% 0;
}
.subtitle {
  color: #6c757d;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}
.section-2 {
  display: flex;
  align-items: center;
}
.asl-link-container {
  padding: 0 80px;
}
.asl-link-container p {
  color: #6c757d;
  font-size: 20px;
  font-weight: 400;
}
.asl-link-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 1rem;
  background: #f8f9fa;
  padding: 1rem;
  margin-bottom: 1rem;
}
.al-link-logo-text {
  display: flex;
  align-items: center;
}
.asl-link-text {
  color: #121416;
  font-size: 24px;
  font-weight: 600;
  margin-left: 12px;
}

@media (max-width: 768px) {
  .container {
    width: calc(100% - 3rem);
    margin: 0 1.5rem;
  }
  .section-1 {
    width: 100%;
    margin: 2.5rem 0 0;
  }
  h1 {
    font-size: 24px;
    font-weight: 600;
  }
  .subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 140%;
  }
  .section-2 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .section-2 img {
    width: 100%;
  }
  .asl-link-container {
    padding: 0;
  }
  .asl-link-container p {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    line-height: 140%;
    margin-bottom: 2.5rem;
  }
  .al-link-logo-text img {
    width: auto;
  }
  .asl-link-text {
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
